import { render, staticRenderFns } from "./SelectRegistrationMethodPage.vue?vue&type=template&id=6ba06f7e&scoped=true&"
import script from "./SelectRegistrationMethodPage.vue?vue&type=script&lang=js&"
export * from "./SelectRegistrationMethodPage.vue?vue&type=script&lang=js&"
import style0 from "./SelectRegistrationMethodPage.vue?vue&type=style&index=0&id=6ba06f7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba06f7e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VBtn,VContainer,VIcon,VRadio,VRadioGroup})
